/**
 * @module stickyHeader
 */
;(function StickyHeader() {
    /**
     * Handle stickyHeader
     * @param $dom {String} $dom identifier
     * @method stickyHeader
     */
    function stickyHeader($dom) {
        /**
         * // local object availability
         * @type {stickyHeader}
         * @private
         */
        var _this = this

        /**
         * @method cacheDom
         *  assign {jQuery|HTMLElement(s)} to object
         */
        this.cacheDom = function () {
            this.$body = $('body')
            this.$window = $(window)
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.cacheDom()
            _this.handleHeight()
            _this.handleSubNavigationHeight()
            _this.render()
        }

        /**
         * @method render
         * @return {undefined}
         */
        this.render = function () {
            _this.bindEvents()
        }

        /**
         * @method bindEvents
         * @return {undefined}
         */
        this.bindEvents = function () {
            _this.$window.resize(function () {
                _this.handleHeight()
                _this.handleSubNavigationHeight()
            })
        }

        /**
         * handle height of header and set as padding top to the body
         * @method handleHeight
         * @return {undefined}
         */
        this.handleHeight = function () {
            document.fonts.ready.then(() => {
                var headerHeight = $($("[data-html-element='header']").first()).outerHeight()
                if (this.headerHeight != headerHeight) {
                    this.headerHeight = headerHeight
                    this.$body.css('padding-top', headerHeight + 'px')
                    document.documentElement.style.setProperty('--scroll-padding-top', (headerHeight + 25) + 'px');
                }
            })
        }

        /**
         * set maxheight for sub navigation to prevent non accessible content
         * @method handleSubNavigationHeight
         * @return {undefined}
         */
        this.handleSubNavigationHeight = function () {
            var windowHeight = _this.$window.height()
            if (this.windowHeight != windowHeight) {
                this.windowHeight = windowHeight
                $dom.find('.main-nav--sub').css('max-height', windowHeight - _this.headerHeight + 'px')
            }
        }

        /**
         * initialize call stickyHeader
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.stickyHeader = stickyHeader
})()

$(document).ready(function () {
    var $stickyHeader = $("[data-html-element='header']").first()
    new window.Creaton.stickyHeader($stickyHeader)
})
